export const URL_BOC = 'https://raboweblogin.rabobank.nl/rwalogin/isapilogin.dll?URL=https://boc.rabobank.nl';
export const URL_GELDOVER = 'https://hub.rabobank.nl/investments/employee-app/dashboard?relationId=';
